import React, { ReactElement } from 'react';
import { CaptchaMode } from '../services/exports/Constants';

export interface ILoadingContext {
  loading: boolean;
  setLoading: (loading: boolean) => void;
  renderLoadingApp: () => ReactElement;
  // How the captcha can render on this host, from the store config the provider loads anyway. Null
  // while that is not known yet: on the web, until the store-config request settles.
  captchaMode: CaptchaMode | null;
}

/**
 * Kept apart from LoadingProvider so that reading it is cheap. The provider imports the menu
 * tree, and the captcha in every login and sign-up form reads `captchaMode` from here; through
 * the provider module it would pull that tree, lottie included, into each of them.
 */
export const LoadingContext = React.createContext<ILoadingContext | null>(null);
